(function () {
  angular.module('MktzapApp.Controllers')
    .controller('EmailBatchController', emailBatchController);

  emailBatchController.$inject = ['$scope', 'EmailBatchService', 'FoundationApi', 'NotificationService', 'LangService', 'ngTableParams', '$rootScope'];

  function emailBatchController ($scope, EmailBatchService, FoundationApi, NotificationService, LangService, ngTableParams, $rootScope) {
    var vm = this;
    vm.tableEmailBatchs = [];
    vm.filter = {};
    vm.emailBatchs = {};
    vm.emailBatch = {};
    vm.emailBatchEdit = {};

    LangService
        .getPageLabels({ 'page': 'menu.master.pdv' })
        .$promise
        .then(function (data) {
            vm.labels = data.lang;
        });

    vm.getEmailBatchs = function() {
        EmailBatchService
            .getAllEmailBatchs(vm.filter)
            .$promise
            .then(function (data) {
                if (data.emailBatchs) {
                    vm.emailBatchs = angular.copy(data.emailBatchs);
                    vm.showFilter = angular.copy(data.emailBatchs);
                    vm.getFiltered(angular.copy(data.emailBatchs));
                    return;
                }

                vm.showFilter = [];
                vm.emailBatchs = [];
                NotificationService.errorHandler(data, vm.labels.errorGetInfo);
            }).catch(function (data) {
                NotificationService.errorHandler(data, vm.labels.errorOperation);
            });
    };

    vm.getEmailBatchs();

    vm.getFiltered = () => {
        vm.tableParams = new ngTableParams({
            page: 1,
            count: 30,
        }, {
            total: vm.showFilter.length,
            getData: function($defer, params) {
                $defer.resolve(vm.showFilter.slice((params.page() - 1) * params.count(), params.page() * params.count()))
                params.total(vm.showFilter.length)
            }
        })
    };
    
    vm.addEmailBatchModal = function() {
        alert('Em desenvolvimento...');
    };

    vm.viewEmailBatch = function(id) {
        EmailBatchService
            .getEmailBatch({id})
            .$promise
            .then(function (data) {
                if (data.emailBatch) {
                    vm.emailBatch = angular.copy(data.emailBatch);
                    FoundationApi.publish('emailBatchModal', 'open');
                    return;
                }

                NotificationService.errorHandler(data, vm.labels.errorGetInfo);
            }).catch(function (data) {
                NotificationService.errorHandler(data, vm.labels.errorOperation);
            });
    };
  }
})();
